import { useCallback, useEffect, useState } from "react";
import { useBackend } from "../lib/backend";
import type { ActiveDesk } from "../lib/services/active-desk";

const DEFAULT_STORAGE_ID = "priced-in-capital";

export function useActiveDesk() {
  const backend = useBackend();
  const [desk, setDesk] = useState<ActiveDesk | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      setDesk(await backend.activeDesk.get());
    } catch (err) {
      setDesk(null);
      setError(err instanceof Error ? err.message : "Active desk unavailable");
    } finally {
      setIsLoading(false);
    }
  }, [backend.activeDesk]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return {
    desk,
    storageId: desk?.storageId ?? DEFAULT_STORAGE_ID,
    isLoading,
    error,
    reload,
  };
}
